const onboarding = {
  businessLogic: {
    title: 'Lógica de negócios',

    areasOfOpertaion: {
      title: 'Zonas de Operação',
      subTitle: 'Mostre-nos onde você opera. Escolha uma cidade, estado ou apenas um bairro, a escolha é sua.',
      hideLightZones: 'Destacar zonas',
    },

    operationPreferences: {
      title: 'Preferências de Operação',
      subTitle: 'Ajuda-nos a conhecê-lo melhor.',

      form: {
        sections: {
          operationPrefernces: {
            header: 'Quais são as suas preferências de operação?',
            operationPreferncesOptions: {
              singleRides: 'Viagens individuais',
              sharedRides: 'Viagens Compartilhadas',
            },
          },

          routingSettings: {
            header: 'Configurações de Rota',
            info: 'Max Doration: duração máxima de uma viagem. Parada máxima: paradas máximas em uma viagem. Proporção: 1,5 significa que a duração de uma pessoa sentada no veículo não excederá 150% do tempo que ela teria gasto conduzindo sozinho. Máximo de Passageiros - número máximo de lugares por viagem.',

            fields: {
              maxDuration: 'Duração máxima',
              paxAtOnce: 'Pagar de uma só vez',
              maxStops: 'Máximo de paradas',
              jobsAtOnes: 'Trabalhos de uma vez',
              maxPassengers: 'Máximo de passageiros',
              rate: 'Taxa',
              pickAll: 'Escolher Tudo',
            },
          },

          pickSettings: {
            header: 'Escolha Configurações',
            info: 'Max Doration: duração máxima de uma viagem. Parada máxima: paradas máximas em uma viagem. Proporção: 1,5 significa que a duração de uma pessoa sentada no veículo não excederá 150% do tempo que ela teria gasto conduzindo sozinho. Máximo de Passageiros - número máximo de lugares por viagem.',

            fields: {
              ambulatory: 'Deslocamento (Mín)',
              wheelchair: 'Cadeira de rodas (Mín)',
              maxEarly: 'Antecipação Máxima (Mínimo)',
              maxLate: 'Atraso máximo (Mínimo)',
            },
          },

          dropSettings: {
            header: 'Configurações de Deixa',
            info: 'Max Doration: duração máxima de uma viagem. Parada máxima: paradas máximas em uma viagem. Proporção: 1,5 significa que a duração de uma pessoa sentada no veículo não excederá 150% do tempo que ela teria gasto conduzindo sozinho. Máximo de Passageiros - número máximo de lugares por viagem.',

            fields: {
              ambulatory: 'Deslocamento (Mín)',
              wheelchair: 'Cadeira de rodas (Mín)',
              maxEarly: 'Antecipação Máxima (Mínimo)',
              maxLate: 'Atraso máximo (Mínimo)',
            },
          },
        },
      },
    },

    fleetDefenition: {
      title: 'Definição de frota',
      subTitle: 'Agora, falemos de frota. Quase pronto!',

      form: {
        sections: {
          assignmentPreferences: {
            header: 'Quais são suas preferências gerais de atribuição de motoristas?',
            fields: {
              defaultCarLocation: 'Localização Padrão de Carro (Endereço)',
              maxDuration: 'Duração máxima do turno (minutos)',
            },
            assignmenOptions: {
              leastVehicles: 'Menor Número <br/> de Veículos',
              balacedVehicles: 'Encaminhamento balanceado',
            },
          },

          vehiclesAndDrivers: {
            header: 'Quantos veículos e motoristas há?',
            vehicles: 'Veículos',
            drivers: 'Motoristas',

            quickEntry: {
              header: 'VIAGEM RÁPida',
              fields: {
                numberOfVehicles: 'Número de veículos',
                wheelChairVehicles: 'Veículos para Cadeira de Rodas',
                numberOfDrivers: 'Número de Motoristas',
                wheelChairDrivers: 'Motoristas de cadeiras de rodas',
              },
            },

            files: {
              header: 'Por favor, indique os seus locais de entrada e saída',
              explanation: 'Explicação sobre o que isso significa exatamente. Explanação e mais explanação e isto poderia ser suficiente.',
              example: 'Por favor, certifique-se de resolver todos os atributos corretamente. ',
              exampleFileText: 'para obter o melhor resultado, fique à vontade para usar o nosso',
              exampleFile: 'arquivo de exemplo',
              trySampleText: 'Sem dados? ',
              trySampleBtn: 'Verifique um exemplo',
            },

            uploadData: {
              header: 'CARREGAR DADOS',
              firstLine: 'Certifique-se de que atende a todos os atributos. Para obter os melhores resultados, sinta',
              secondLine: {
                firsTpart: 'livre para usar o nosso',
                vehicle: 'Arquivo de exemplo de veículos',
                and: 'e',
                drivers: 'Arquivo de exemplo de motoristas',
              },
            },
          },
        },
      },
    },

    scheduleAutomation: {
      title: 'Automação do Planejamento',
      subTitle: 'Ajuda-nos a conhecê-lo melhor.',
    },

    additionalFeatures: {
      title: 'Funcionalidades Adicionais',
      subTitle: 'Quanto mais sabermos, melhor serviço seremos capazes de prestar.',

      form: {
        file: {
          header: 'Por favor, indique os seus locais de entrada e saída',
          explanation: 'Explicação sobre o que isso significa exatamente. Explanação e mais explanação e isto poderia ser suficiente.',
          example: 'Por favor, certifique-se de resolver todos os atributos corretamente. ',
          exampleFileText: 'para obter o melhor resultado, fique à vontade para usar o nosso',
          exampleFile: 'arquivo de exemplo',
          trySampleText: 'Sem dados? ',
          trySampleBtn: ' Tente um exemplo.',
        },

        willCall: {
          header: 'Deseja habilitar a opção "Ligará"?',
          info: 'Max Doration: duração máxima de uma viagem. Parada máxima: paradas máximas em uma viagem. Proporção: 1,5 significa que a duração de uma pessoa sentada no veículo não excederá 150% do tempo que ela teria gasto conduzindo sozinho. Máximo de Passageiros - número máximo de lugares por viagem.',
          on: 'Em',
          off: 'Desativado',
          time: 'Tempo',
          attribute: 'Atributo',
          explanation: 'Por favor, certifique-se de resolver a propriedade do atributo em seus arquivos de demanda',
        },
      },
    },
  },

  assets: {
    title: 'Ativos',
    fleetDefinition: {
      title: 'Definição de frota',
      subTitle: 'Agora, falemos de frota. Quase pronto!',
    },
  },

  demand: {
    title: 'Demanda',

    dataUpload: {
      title: 'Carregar dados',
      subTitle: 'Alimente-me com a Demanda e estamos pronto para começar!',

      form: {
        file: {
          explanation: 'Por favor, certifique-se de resolver todos os atributos corretamente. Para a melhor sensação de resultado ',
          example: 'livre para usar o nosso',
          exampleFile: 'arquivo de exemplo',
          trySampleText: 'Sem dados?',
          trySampleBtn: 'Verifique um exemplo',
        },
      },
    },
  },

  save: 'Próximo',

  kpi: {
    title: 'Tarefas Concluídas',
    wellDone: 'Muito bem!',
    labels: {
      onboardingKpiCompleted: 'Completo',
    },
  },

  submit: {
    text: 'E é isso! Estamos prontos. se você ficou satisfeito com suas respostas e não quiser mudar nada, vá em frente e crie você cenário customizado.',
    create: 'CRIAR CENÁRIO',
  },
};

export default onboarding;
